<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-07-29 09:10:10
 * @LastEditTime : 2022-07-29 11:56:43
 * @LastEditors  : yangxr
 * @Description  : 地磅维护
 * @FilePath     : \icps_fb\src\views\platform\ICPS\basicConfig\components\siteMaintain.vue
-->
<template>
  <el-dialog v-dialogDrag :visible.sync="siteDialog" width="1080px" :close-on-click-modal="false" :append-to-body="true" :before-close="onclose">
    <span slot="title" class="dialog-title">{{ siteDialogTitle }}</span>
    <div class="dialoginfo">
      <div style="position: relative; margin-bottom: 10px; height: 30px">
        <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" :disabled="modifyType" @click="addItem()">添加</el-button>
      </div>
      <el-table ref="multipleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="stationInfo.weightList" tooltip-effect="dark">
        <el-table-column label="地磅名称" align="center" :min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.weightName" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="IP" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.com" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="端口" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.baudRate" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column label="串口号" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.com" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="比特率" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.baudRate" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="数据位" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.dataBit" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="停止位" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.stopBit" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="校验位" align="center" :min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.checkBit" style="width: 100%" :disabled="modifyType" :controls="false"></el-input>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" prop="specification" width="200">
          <template slot-scope="scope">
            <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItem(scope.$index, scope.row)">
              <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onclose">取 消</el-button>
      <el-button class="bottom_two" :disabled="modifyType" @click="saveSiteInfo()"> 保 存 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getStationInfo, saveOrUpdateStation } from "@/api/basicConfig/site.js";
export default {
  name: "siteMaintain",
  data() {
    return {
      modifyType: false,
      list: [],
      tableParam: {
        page: 1,
        pageSize: 10,
        driverName: "",
        type: 2,
      },
      stationInfo: "",
      siteDialogTitle: "地磅维护",
      planData: {},
    };
  },
  props: {
    siteDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    //获取列表
    getSiteList(stationInfo) {
      if (stationInfo) {
        this.stationInfo = stationInfo;
      }
      getStationInfo({ stationId: stationInfo.stationId }).then(res => {
        if (res.code == 1001) {
          if (res.data) {
            this.stationInfo.weightList = res.data;
          } else {
            this.stationInfo.weightList = [];
          }
        }
      });
    },
    //删除
    deleteItem(index) {
      this.stationInfo.weightList.splice(index, 1);
    },
    //添加
    addItem() {
      let item = {
        weightName: "",
        com: "",
        baudRate: "",
        dataBit: "",
        stopBit: "",
        checkBit: "",
      };
      this.stationInfo.weightList.push(item);
    },
    /*公司信息弹窗*/
    onclose() {
      this.$emit("update:siteDialog", false);
    },
    /*保存/修改公司信息弹窗*/
    saveSiteInfo() {
      let status = false;
      this.stationInfo.weightList.forEach(item => {
        // if (item.weightName && item.com && item.baudRate && item.dataBit && item.stopBit && item.checkBit) {
        if (item.weightName && item.com && item.baudRate) {
          status = false;
        } else {
          status = true;
        }
      });
      if (status) {
        this.$message.warning("请检查表格数据是否完整");
        return;
      }
      saveOrUpdateStation(this.stationInfo).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.onclose();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}
.el-form-item__label {
  color: #000000;
  font-size: 14px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
</style>
